import logo from "@/assets/ssg-logo.jpeg";
import { fmtTime, fmtDate, motifLabel } from "@/lib/format";

export const PrintableReport = ({ visitors, stats, filterLabel }) => {
  const today = new Date();
  return (
    <div id="printable-report" className="hidden">
      <div style={{ display: "flex", alignItems: "center", gap: 16, borderBottom: "3px solid #0A192F", paddingBottom: 12, marginBottom: 16 }}>
        <img src={logo} alt="SSG" style={{ height: 64, width: 64, objectFit: "contain" }} />
        <div>
          <h1 style={{ fontFamily: "Cinzel, serif", fontSize: 22, margin: 0, color: "#0A192F" }}>
            RAPPORT JOURNALIER DES VISITEURS
          </h1>
          <p style={{ margin: "2px 0 0", fontSize: 13, color: "#8B6B1B", letterSpacing: 1 }}>
            SSG · Poste de Sécurité — {filterLabel}
          </p>
          <p style={{ margin: "2px 0 0", fontSize: 12, color: "#555" }}>
            Édité le {fmtDate(today.toISOString())} à {fmtTime(today.toISOString())}
          </p>
        </div>
      </div>

      {stats && (
        <div style={{ display: "flex", gap: 24, marginBottom: 16, fontSize: 13 }}>
          <div><b>Sur site :</b> {stats.on_site}</div>
          <div><b>Arrivées (jour) :</b> {stats.arrivals_today}</div>
          <div><b>Départs (jour) :</b> {stats.departures_today}</div>
          <div><b>Présences &gt;4h :</b> {stats.overstay}</div>
          <div><b>Total affiché :</b> {visitors.length}</div>
        </div>
      )}

      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
        <thead>
          <tr style={{ background: "#0A192F", color: "#fff" }}>
            {["Badge", "Nom", "Société", "Téléphone", "Personne visitée", "Service", "Motif", "Arrivée", "Départ", "Statut"].map((h) => (
              <th key={h} style={{ padding: "6px 8px", textAlign: "left", border: "1px solid #0A192F" }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {visitors.map((v) => (
            <tr key={v.id}>
              <td style={cell}>{v.badge || "—"}</td>
              <td style={cell}>{v.nom}</td>
              <td style={cell}>{v.societe || "—"}</td>
              <td style={cell}>{v.telephone || "—"}</td>
              <td style={cell}>{v.personne_visitee}</td>
              <td style={cell}>{v.service || "—"}</td>
              <td style={cell}>{motifLabel(v)}</td>
              <td style={cell}>{fmtTime(v.heure_arrivee)}</td>
              <td style={cell}>{v.heure_depart ? fmtTime(v.heure_depart) : "—"}</td>
              <td style={cell}>{v.heure_depart ? "Parti" : "Présent"}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ marginTop: 48, display: "flex", justifyContent: "space-between", fontSize: 12 }}>
        <div>Agent de garde : _______________________</div>
        <div>Signature : _______________________</div>
      </div>
    </div>
  );
};

const cell = { padding: "5px 8px", border: "1px solid #cbd5e1" };
